<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelTipos"
    :multiple="isMulti"
    :taggable="isTagabble"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    label="nome"
    :allowEmpty="false"
    :preselectFirst="true"
    :loading="isLoading"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
    class="multiselect-primary"
    inputContainerClass="d-flex"
    :hide-selected="true"
  >
    <template slot="tag" slot-scope="{ option, remove }" class="d-flex">
      <span class="multiselect__tag">
        <span>{{ option.nome }}</span>
        <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="remove(option)"></i>
      </span>
    </template>
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: [
    'nameField',
    'alreadySelected',
    'isRequired',
    'isDisabled',
    'emptyLabel',
    'includeAll',
    'isMulti',
    'isTagabble'
  ],

  data() {
    return {
      selected: null,
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      if (e == null) {
        this.$emit('selectChange', 'id_perfil_metabase_dashboard', null);
        return;
      }
      if (this.isMulti) {
        let arr = new Array();
        e.forEach((el) => {
          arr.push(el.id);
        });
        this.$emit('selectChange', 'id_perfil_metabase_dashboard', arr);
      } else {
        this.$emit('selectChange', 'id_perfil_metabase_dashboard', e.id);
      }
    },
    labelTipos({ nome }) {
      return `${this.$i18n.t(nome)}`;
    },
    setValue(value) {
      if (value) {
        if (this.isMulti) {
          this.selected = [];
          value.forEach((el) => {
            this.selected.push(this.options.find((option) => option.id === el));
          });
        } else {
          this.selected = this.options.find((option) => option.id === parseInt(value));
        }
      } else {
        this.selected = this.options.find((option) => option.id === null);
      }
      this.$emit('input', this.selected);
    },

    setOptions() {
      this.isLoading = true;
      this.$atenaList
        .getCommon('perfil_metabase_dashboard', {
          columns: 'id, nome',
          filter: `id_empresa=${this.$util.getIdEmpresa()}`,
          order: 'id'
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$util.formWarn({
            msgTitle: 'Erro',
            msgContent: `${err.code} - ${err.message}`,
            msgTranslate: false,
            type: 'error'
          });
        });
    }
  },

  watch: {
    nameField: function (value) {
      this.setValue(value);
    }
  },

  created() {
    this.setOptions();
  }
};
</script>

<style lang="scss">
.multiselect-primary {
  .multiselect__tags {
    display: flex !important;
  }
}
</style>
